import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Aggregate,
  AggregateColumnsDirective,
  AggregateColumnDirective,
  AggregateDirective,
  AggregatesDirective,
  Edit,
  Toolbar,
  Group,
  Sort,
  Inject,
  FilterSettingsModel,
  Filter,
  ExcelExport,
  ExcelQueryCellInfoEventArgs,
  Reorder,
  Resize,
  // PdfQueryCellInfoEventArgs,
} from "@syncfusion/ej2-react-grids";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { ClickEventArgs } from "@syncfusion/ej2-navigations";
import { useRef } from "react";

import { FORType } from "../../../../db/model";
import ErrorBoundary from "../../../../ErrorBoundary";

let refresh: Boolean;

function ForComponent({ forData }: { forData: FORType[] }) {
  const gridInstance = useRef<GridComponent>(null);
  const alertDialogInstance = useRef<DialogComponent>(null);

  const filterSettings: FilterSettingsModel = { type: "Excel" };
  const toolbarOptions: any = ["ExcelExport"];
  const editSettings: any = { allowEditing: false };
  // const editparams: any = { params: { popupHeight: "300px" } };
  // const partyNameRule: Object = { required: true };
  // const orderNoRules: Object = { required: true };
  const dateFormat: any = { type: "date", format: "dd-MMM-yyyy" };

  // const groupOptions: Object = { showGroupedColumn: false, columns: ["rate"] };
  const groupOptions: Object = { showGroupedColumn: false, columns: [] };
  const visible = false;
  const animationSettings: Object = { effect: "None" };
  const alertButtons = [
    {
      click: () => {
        alertDialogInstance.current?.hide();
      },
      buttonModel: { content: "OK", isPrimary: true },
    },
  ];

  function dataBound() {
    if (refresh) {
      gridInstance.current?.groupColumn("rate");

      refresh = false;
    }
  }

  function exportQueryCellInfo(args: ExcelQueryCellInfoEventArgs) {
    // if (args.column!.headerText === "Employee Image") {
    //   if ((args as any).name === "excelQueryCellInfo") {
    //     args.image = {
    //       height: 75,
    //       base64: args.data["EmployeeImage"],
    //       width: 75,
    //     };
    //   } else {
    //     args.image = { base64: args.data["EmployeeImage"] };
    //   }
    // }
    // if (args.column!.headerText === "Email ID") {
    //   args.hyperLink = {
    //     target: "mailto:" + args.data["EmailID"],
    //     displayText: args.data["EmailID"],
    //   };
    // }
  }

  function load() {
    // to do
  }

  function columnDragStart(args: any) {
    if (args.column.field === "referenceNo") {
      alertDialogInstance.current?.show();
    }
  }

  function created() {
    gridInstance.current?.on("columnDragStart", columnDragStart);
  }

  function toolbarClick(args: ClickEventArgs): void {
    if (args.item.id?.endsWith("_excelexport")) {
      console.log("args.item.id");
      console.log(args.item.id);
      if (gridInstance.current) {
        gridInstance.current.excelExport();
      }
    }
  }

  let modifiedForData = forData.map((item) => {
    return {
      ...item,
      invoiceDate: item.invoiceDate ? new Date(item.invoiceDate) : null,
      receiptDate: item.receiptDate ? new Date(item.receiptDate) : null,
      wcDate: item.wcDate ? new Date(item.wcDate) : null,
      packingListDate: item.packingListDate
        ? new Date(item.packingListDate)
        : null,
    };
  });

  function amountSum(props: any) {
    return <span>Sum: {props.Sum.toFixed(2)}</span>;
  }

  return (
    <ErrorBoundary>
      <div className="w-full pb-12 min-h-screen">
        <div className="control-pane mx-auto py-3">
          <div className="control-section">
            <GridComponent
              className="mx-auto dark:bg-slate-950"
              dataSource={modifiedForData}
              allowPaging={true}
              allowExcelExport={true}
              ref={gridInstance}
              toolbar={toolbarOptions}
              toolbarClick={(e) => toolbarClick(e)}
              pageSettings={{ pageCount: 5, pageSize: 15 }}
              allowFiltering={true}
              enableAltRow={true}
              filterSettings={filterSettings}
              editSettings={editSettings}
              allowGrouping={true}
              groupSettings={groupOptions}
              allowSorting={true}
              rowHeight={25}
              height="auto"
              dataBound={() => dataBound()}
              excelQueryCellInfo={(e) => exportQueryCellInfo(e)}
              load={load}
              created={created}
              allowReordering={true}
              allowResizing={true}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="invoiceNo"
                  headerText="Invoice No."
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="invoiceDate"
                  headerText="Invoice Date"
                  width="150"
                  textAlign="Left"
                  format={dateFormat}
                />
                <ColumnDirective
                  field="orderCategory"
                  headerText="Order Category"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="receiptNo"
                  headerText="Receipt No."
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="receiptDate"
                  headerText="Receipt Date"
                  width="150"
                  textAlign="Left"
                  format={dateFormat}
                />
                <ColumnDirective
                  field="partyName"
                  headerText="Party Name"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="wcNo"
                  headerText="WC No."
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="wcDate"
                  headerText="WC Date"
                  width="150"
                  textAlign="Left"
                  format={dateFormat}
                />
                <ColumnDirective
                  field="wcsNo"
                  headerText="WCS No."
                  width="130"
                  textAlign="Right"
                />
                <ColumnDirective
                  field="clientPO"
                  headerText="Client PO"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="shade"
                  headerText="Shade"
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="orderForm"
                  headerText="Order Form"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="category"
                  headerText="Category"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="fabric"
                  headerText="Fabric"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="hsnCode"
                  headerText="HSN Code"
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="sacCode"
                  headerText="SAC Code"
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="quantity"
                  headerText="Quantity"
                  width="120"
                  textAlign="Right"
                  // format="N0" // Assuming the quantity is a whole number
                />
                <ColumnDirective
                  field="billingQuantity"
                  headerText="Billing Quantity"
                  width="150"
                  textAlign="Right"
                  format="N0"
                />
                <ColumnDirective
                  field="rate"
                  headerText="Rate"
                  width="120"
                  textAlign="Right"
                  // format="C2" // Assuming rate is a currency
                />
                <ColumnDirective
                  field="unit"
                  headerText="Unit"
                  width="100"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="freightRate"
                  headerText="Freight Rate"
                  width="130"
                  textAlign="Right"
                  // format="C2"
                />
                <ColumnDirective
                  field="packingListNo"
                  headerText="Packing List No."
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="packingListDate"
                  headerText="Packing List Date"
                  width="150"
                  textAlign="Left"
                  format={dateFormat}
                />
                <ColumnDirective
                  field="basicAmount"
                  headerText="Basic Amount"
                  width="150"
                  textAlign="Right"
                  // format="C2"
                />
                <ColumnDirective
                  field="freight"
                  headerText="Freight"
                  width="130"
                  textAlign="Right"
                  // format="C2"
                />
                <ColumnDirective
                  field="otherCharges"
                  headerText="Other Charges"
                  width="150"
                  textAlign="Right"
                  // format="C2"
                />
                <ColumnDirective
                  field="taxableAmount"
                  headerText="Taxable Amount"
                  width="150"
                  textAlign="Right"
                  // format="C2"
                />
                <ColumnDirective
                  field="cgstRate"
                  headerText="CGST Rate"
                  width="130"
                  textAlign="Right"
                  // format="P2" // Assuming percentage format
                />
                <ColumnDirective
                  field="cgstAmount"
                  headerText="CGST Amount"
                  width="150"
                  textAlign="Right"
                  // format="C2"
                />
                <ColumnDirective
                  field="sgstRate"
                  headerText="SGST Rate"
                  width="130"
                  textAlign="Right"
                  // format="P2"
                />
                <ColumnDirective
                  field="sgstAmount"
                  headerText="SGST Amount"
                  width="150"
                  textAlign="Right"
                  // format="C2"
                />
                <ColumnDirective
                  field="igstRate"
                  headerText="IGST Rate"
                  width="130"
                  textAlign="Right"
                  // format="P2"
                />
                <ColumnDirective
                  field="igstAmount"
                  headerText="IGST Amount"
                  width="150"
                  textAlign="Right"
                  // format="C2"
                />
                <ColumnDirective
                  field="totalAmount"
                  headerText="Total Amount"
                  width="180"
                  textAlign="Right"
                  // format="C2"
                />
                <ColumnDirective
                  field="fabricType"
                  headerText="Fabric Type"
                  width="180"
                  textAlign="Left"
                />
              </ColumnsDirective>
              <AggregatesDirective>
                <AggregateDirective>
                  <AggregateColumnsDirective>
                    <AggregateColumnDirective
                      field="quantity"
                      type="Sum"
                      groupFooterTemplate={amountSum}
                      footerTemplate={amountSum}
                    />
                  </AggregateColumnsDirective>
                </AggregateDirective>
              </AggregatesDirective>
              <Inject
                services={[
                  Page,
                  Toolbar,
                  ExcelExport,
                  Aggregate,
                  Group,
                  Sort,
                  Edit,
                  Filter,
                  Reorder,
                  Resize,
                ]}
              />
            </GridComponent>
            <DialogComponent
              id="alertDialog"
              header="Grouping"
              visible={visible}
              animationSettings={animationSettings}
              width="300px"
              content="Grouping is disabled for this column"
              ref={alertDialogInstance}
              target=".control-section"
              buttons={alertButtons}
            />
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default ForComponent;
